"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceIntoLivingEventDTO = void 0;
const enums_1 = require("../enums");
class PlaceIntoLivingEventDTO {
    // index is the index in living array to place the thing
    // to maintain drag and drop order
    constructor(payload) {
        this.name = enums_1.Level1EventName.PLACE_THING_INTO_LIVING;
        this.payload = payload;
    }
}
exports.PlaceIntoLivingEventDTO = PlaceIntoLivingEventDTO;
//# sourceMappingURL=PlaceIntoLivingEventDTO.js.map